import { PostMessageBridge } from "@kalyzee/simple-communication-bridge";
import { PostMessageAPI } from "./schema";

export class PostMessageBridgeIn extends PostMessageBridge<PostMessageAPI, 'in'> {
    constructor(window: Window, targetOrigin: string) {
        super(window, targetOrigin);
    }
};